import api from '../client'

export const igamingApi = {
  getRuntimeConfig: async (orgSlug, params = {}) => {
    const response = await api.get(`/${orgSlug}/igaming/runtime-config`, { params })
    return response.data
  },
  listRules: async (orgSlug, params = {}) => {
    const response = await api.get(`/${orgSlug}/igaming/rules`, { params })
    return response.data
  },
  createRule: async (orgSlug, payload) => {
    const response = await api.post(`/${orgSlug}/igaming/rules`, payload)
    return response.data
  },
  updateRule: async (orgSlug, id, payload) => {
    const response = await api.patch(`/${orgSlug}/igaming/rules/${id}`, payload)
    return response.data
  },
  disableRule: async (orgSlug, id) => {
    await api.post(`/${orgSlug}/igaming/rules/${id}/disable`)
  },
  deleteRule: async (orgSlug, id) => {
    await api.delete(`/${orgSlug}/igaming/rules/${id}`)
  },
  previewRule: async (orgSlug, payload) => {
    const response = await api.post(`/${orgSlug}/igaming/rules/preview`, payload)
    return response.data
  },
  getAnalytics: async (orgSlug, params = {}) => {
    const response = await api.get(`/${orgSlug}/igaming/analytics`, { params })
    return response.data
  },
  downloadAnalytics: async (orgSlug, params = {}) => {
    const response = await api.get(`/${orgSlug}/igaming/analytics/export`, {
      params,
      responseType: 'blob',
    })
    return response.data
  },
  listPromotions: async (orgSlug, params = {}) => {
    const response = await api.get(`/${orgSlug}/igaming/promotions`, { params })
    return response.data
  },
  createPromotion: async (orgSlug, payload) => {
    const response = await api.post(`/${orgSlug}/igaming/promotions`, payload)
    return response.data
  },
  updatePromotion: async (orgSlug, id, payload) => {
    const response = await api.patch(`/${orgSlug}/igaming/promotions/${id}`, payload)
    return response.data
  },
  deletePromotion: async (orgSlug, id) => {
    await api.delete(`/${orgSlug}/igaming/promotions/${id}`)
  },
  listJackpotPools: async (orgSlug, params = {}) => {
    const response = await api.get(`/${orgSlug}/igaming/jackpot-pools`, { params })
    return response.data
  },
  createJackpotPool: async (orgSlug, payload) => {
    const response = await api.post(`/${orgSlug}/igaming/jackpot-pools`, payload)
    return response.data
  },
  updateJackpotPool: async (orgSlug, id, payload) => {
    const response = await api.patch(`/${orgSlug}/igaming/jackpot-pools/${id}`, payload)
    return response.data
  },
  deleteJackpotPool: async (orgSlug, id) => {
    await api.delete(`/${orgSlug}/igaming/jackpot-pools/${id}`)
  },
  listGameOverrides: async (orgSlug, params = {}) => {
    const response = await api.get(`/${orgSlug}/igaming/game-overrides`, { params })
    return response.data
  },
  createGameOverride: async (orgSlug, payload) => {
    const response = await api.post(`/${orgSlug}/igaming/game-overrides`, payload)
    return response.data
  },
  updateGameOverride: async (orgSlug, id, payload) => {
    const response = await api.patch(`/${orgSlug}/igaming/game-overrides/${id}`, payload)
    return response.data
  },
  deleteGameOverride: async (orgSlug, id) => {
    await api.delete(`/${orgSlug}/igaming/game-overrides/${id}`)
  },
  listDataSources: async (orgSlug, params = {}) => {
    const response = await api.get(`/${orgSlug}/igaming/data-sources`, { params })
    return response.data
  },
  createDataSource: async (orgSlug, payload) => {
    const response = await api.post(`/${orgSlug}/igaming/data-sources`, payload)
    return response.data
  },
  updateDataSource: async (orgSlug, id, payload) => {
    const response = await api.patch(`/${orgSlug}/igaming/data-sources/${id}`, payload)
    return response.data
  },
  deleteDataSource: async (orgSlug, id) => {
    await api.delete(`/${orgSlug}/igaming/data-sources/${id}`)
  },
  listMetadataReviews: async (orgSlug, params = {}) => {
    const response = await api.get(`/${orgSlug}/igaming/metadata-reviews`, { params })
    return response.data
  },
  createMetadataReview: async (orgSlug, payload) => {
    const response = await api.post(`/${orgSlug}/igaming/metadata-reviews`, payload)
    return response.data
  },
  updateMetadataReview: async (orgSlug, id, payload) => {
    const response = await api.patch(`/${orgSlug}/igaming/metadata-reviews/${id}`, payload)
    return response.data
  },
  deleteMetadataReview: async (orgSlug, id) => {
    await api.delete(`/${orgSlug}/igaming/metadata-reviews/${id}`)
  },
}
